<script>
import Template from "../../content/elements/template.vue";

export default {
    name: "dialog-button",
    components: {Template},
    props: {
        color: {
            type: String,
            default: 'secondary'
        },
        small: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tooltip: String
    },
    methods: {
        handleClick(value) {
            this.$emit('click', value)
        }
    },
    computed: {
        buttonClass() {
            return `btn btn-${this.color} ${this.disabled ? 'dialog-button-disabled' : ''} ${this.color === 'success' ?
                'dialog-button-success' : this.color === 'error' ? 'dialog-button-error' : ''}`;
        }
    }
}
</script>

<template>
    <v-tooltip v-if="tooltip" top>
        <template v-slot:activator="{ on }">
            <div v-on="on">
                <v-btn
                    :class="buttonClass"
                    :small="small"
                    :disabled="disabled"
                    @click="handleClick"
                >
                    <slot/>
                </v-btn>
            </div>
        </template>
        <span v-if="tooltip">{{tooltip}}</span>
    </v-tooltip>
    <v-btn v-else
        :class="buttonClass"
        :small="small"
        :disabled="disabled"
        @click="handleClick"
    >
        <slot/>
    </v-btn>
</template>

<style>
    .dialog-button-disabled {
        border-color: rgba(0,0,0,.12)!important;
    }
    .v-btn__content {
        height: 100%;
        width: 100%;
    }
    .v-btn__content label {
        height: 100%;
        width: 100%;
        align-content: center;
    }
</style>
